import { render, staticRenderFns } from "./AllOrderLogistics.vue?vue&type=template&id=24d9200c&"
import script from "./AllOrderLogistics.vue?vue&type=script&lang=js&"
export * from "./AllOrderLogistics.vue?vue&type=script&lang=js&"
import style0 from "./AllOrderLogistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports